import React from 'react';
// import './RelatedSidebar.css';

function RelatedSidebar() {
    return (
        <aside className="related-sidebar" id="related">
            <h3 className="related-title">Related</h3>
            <ul>
                <li><a href="#how-to-apply">How to apply</a></li>
                <li><a href="https://osap.gov.on.ca/AidEstimator2425Web/enterapp/enter.xhtml">OSAP Aid Estimator</a></li>
                <li><a href="https://www.ontario.ca/page/after-you-apply-osap">After you apply</a></li>
                <li><a href="https://www.ontario.ca/page/how-maintain-eligibility-osap-and-ontario-learn-and-stay-grant">How to maintain eligibility for OSAP</a></li>
                <li><a href="https://www.ontario.ca/page/pay-back-osap">Repay your loan</a></li>
                <li><a href="https://osap.gov.on.ca/SchoolSearchWeb/search/school_search.xhtml">Approved schools</a></li>
            </ul>
        </aside>
    );
}

export default RelatedSidebar;